import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './RegisterPage.css';

// Importando os ícones do Material Icons
import { Person, Email, Phone, Lock, LockOpen, Wc } from '../icons';

// Importando a biblioteca de máscara
import InputMask from 'react-input-mask';

const Login = () => {
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [gender, setGender] = useState("");
  const [error, setError] = useState("");

  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate(); 

  const handleSubmit = (event) => {
    event.preventDefault(); // Para evitar o comportamento padrão de recarregar a página

    if (name.length < 2) {
      alert("Por favor, preencha o campo nome.");
      return;
    }

    if (lastName.length < 2) {
      alert("Por favor, preencha o campo sobrenome.");
      return;
    }

    if (phone.length !== 15) {
      alert("Por favor, insira um número de telefone válido.");
      return;
    }

    if (gender !== "male" && gender !== "female") {
      alert("Por favor, selecione seu sexo.");
      return;
    }

    if ((password !== confirmPassword) || (password.length < 6 || confirmPassword.length < 6)) {
      alert("Verifique as senhas digitadas, elas devem ser iguais e ter mais que 6 caracters.");
      return;
    }

    handleLogin()
  }


  const handleLogin = async () => {
    const registerData = {name, lastName, email, phone, password, gender}
    axios.post(`${apiUrl}register`, { registerData })
    .then((response) => {
      navigate('/', { state: { registerSuccess: true} })
    })
    .catch((err) => {
      alert("E-mail já está sendo utilizado, por favor insira um diferente.");
    });
  };

  return (
    <div className="register-container">
      <Helmet>
        <title>Cadastro - Preparate Questões</title>
        <meta name="description" content="Crie sua conta gratuita na Preparate e comece a estudar com simulados e questões de concursos atualizadas." />
        <link rel="canonical" href="https://user.preparatequestoes.com.br/cadastro" />
      </Helmet>
      <div className="login-card">
        <h2>Cadastro Preparate Questões</h2>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <div className="input-container">
                <Person className="input-icon" />
                <label className="label-register">Nome</label>
            </div>
            <input className="input-container"
              type="text"
              value={name}
              maxLength={20} 
              onChange={(e) => setName(e.target.value)}
              placeholder="Digite seu nome"
            />
          </div>

          <div className="input-group">
            <div className="input-container">
                <Person className="input-icon" />
                <label className="label-register">Sobrenome</label>
            </div>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder="Digite seu sobrenome"
              maxLength={50}  // Limite máximo de caracteres
            />
          </div>

          <div className="input-group">
            <div className="input-container">
                <Wc className="input-icon" />
                <label className="label-register">Sexo</label>
            </div>
            <select value={gender} onChange={(e) => setGender(e.target.value)}>
              <option value="">Selecione</option>
              <option value="male">Masculino</option>
              <option value="female">Feminino</option>
            </select>
          </div>

          <div className="input-group">
            <div className="input-container">
                <Phone className="input-icon" />
                <label className="label-register">Celular</label>
            </div>
            {/* Aplicando a máscara de celular */}
            <InputMask
              mask="(99) 99999-9999"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            >
              {(inputProps) => <input {...inputProps} placeholder="Digite seu celular" />}
            </InputMask>
          </div>

          <div className="input-group">
            <div className="input-container">
                <Email className="input-icon" />
                <label className="label-register">E-mail</label>
            </div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Digite seu e-mail"
              maxLength={40}  // Limite máximo de caracteres
            />
          </div>

          <div className="input-group">
            <div className="input-container">
                <Lock className="input-icon" />
                <label className="label-register">Senha</label>
            </div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Crie sua senha"
              maxLength={16}  // Limite máximo de caracteres
            />
          </div>

          <div className="input-group">
            <div className="input-container">
                <LockOpen className="input-icon" />
                <label className="label-register">Confirme sua senha</label>
            </div>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirme sua senha"
              maxLength={16}  // Limite máximo de caracteres
            />
          </div>

          {error && <p className="error-text">{error}</p>}
          <button type="submit" className="btn-submit">Cadastrar</button>
        </form>
      </div>
    </div>
  );
};

export default Login;